module.exports = __webpack_public_path__ + "static/img/green_button.a079aaf0.png";